<template>
	<v-dialog  
	 	v-model="dialog"
		:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		:max-width="maxWidth"
	>
		<!-- Актіватор -->
		<template v-slot:activator="{ on: dialog, attrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip, attrs }">
					<slot name="activator" :attrs="attrs" :dialog="dialog" :tooltip="tooltip">
						<v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</slot>
				</template>
				<span>{{ $vuetify.lang.t(`$vuetify.${tooltip}`) | capitalize }}</span>
			</v-tooltip>
		</template>

		<v-card>
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text>
				<v-form ref="form">
					<v-row class="mt-3">
						<v-col cols="12">
							<v-text-field
								:label="$vuetify.lang.t('$vuetify.name') | capitalize"
								v-model="item.name"
								clearable
								outlined
								dense
								hide-details="auto"
							></v-text-field>
						</v-col>
						<!-- <v-col cols="12" md="4">
							<v-text-field
								:label="$vuetify.lang.t('$vuetify.code') | capitalize"
								v-model="item.code"
								clearable
								outlined
								dense
								hide-details="auto"
							></v-text-field>
						</v-col> -->
						<v-col cols="12" md="6">
							<v-select
								v-model="item.type"
								:items="types"
								label="Тип"
								item-text="name"
								item-value="id"
								outlined
								dense
								hide-details="auto"
								return-object
								:rules="[rules.required, rules.onlyFromList]"
							>
								<template v-slot:item="{ on, item }">
									<v-list-item v-on="on">
										<v-list-item-content>
											<v-list-item-title>{{ item.name }}</v-list-item-title>
											<!-- <v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle> -->
										</v-list-item-content>
									</v-list-item>
								</template>
							</v-select>
						</v-col>
						<v-col cols="12" md="6">
							<z-date 
								v-model="item.date"
								label="Дата"
								outlined
								dense
								hide-details="auto"
								:rules="[rules.required]"
							></z-date>
						</v-col>
						<v-col cols="12">
							<v-textarea
								v-model="item.description"
								:label="$vuetify.lang.t('$vuetify.comment') | capitalize"
								hint=""
								rows="2"
								outlined
								dense
								hide-details="auto"
							></v-textarea>
						</v-col>
					</v-row>
				</v-form>
				
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
import zDate from '@/views/components/control/Date2'

export default {
	name: 'DialogDetailVehicleParkEstimate',
	mixins: [mixin],
	components: { zDate },
	data: () => ({
		item: {},
		loadings: {
			type: false,
		},
	}),

	props: {
		title: 				{ type: String, default: 'Оцінка' },
		icon: 				{ type: String, default: 'mdi-ruler-square-compass' },
		maxWidth: 			{ type: Number, default: 600 },
		park: 				{ type: Object, default: () => {} },
	},

	computed: {
		...mapGetters('VehicleParkEstimateType', { types: 'items' }),

		id() {
			return this.item?.id ? this.item.id : null
		},
	},

	created () {
		//console.log(this.$options.name, 'created')

		//this.$set(this.item, 'date', (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))

		if(this.types.length == 0) {
			this.loadings.type = true
			this.loadType().then(() => this.$set(this.item, 'type', this.types[0])).finally(() => (this.loadings.type = false));
		}
	},

	methods: {
		//...mapActions('VehicleRequest', [ 'setItem' ]),
		...mapActions('VehicleParkEstimateType', { loadType: 'load'}),
		
		onOpen () {
			//console.log('details.mixin.main', 'onOpen','selected', this.selected)

			//this.item = {};

			this.onClear()

			if(this.selected) {
				this.item = { ...this.selected };
			}

			/* this.setItem();

			if(this.selected) {
				this.setItem({...this.selected});
			} */

			//console.log(this.$options.name, 'onOpen','item', this.item)
		},

		onClear() {
			//this.$refs.form.reset()
			//this.clear()

			this.item = {
				date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
				type: this.types[0],
				park: { id: this.park.id },
			};
		},

		onOK() {
			let that = this

			//console.log(this.$options.name, 'onOK', 'item', this.item)

			if(this.$refs.form.validate()) {
				this.loading = true
				axios.post('/vehicle/park/estimate', this.item).then(response => {
					//console.log(this.$options.name, 'onOK','response.data', response.data)
					this.$emit('ok', response.data)
					that.dialog = false
				}, error => {
					console.log(error)
				}).finally(() => {
					this.loading = false
				});
			}

			/* if(this.$refs.parameters.validate()) {
				if(this.selected) {
					//this.selected = {...this.item}
					this.$emit('edit', {...this.item})
				} else {
					this.$emit('add', {...this.item})
				}

				this.dialog = false
			} */
		},
	},
}
</script>